import React from 'react';

import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import { RequestErrorModal } from 'js/src/components/common/RequestErrorModal';
import { Toast } from 'js/src/components/common/Toast';
import ContentfulPage from 'js/src/components/public-pages/ContentfulPage';
import { ImmutableFromJS, type ImmutableMap } from 'js/src/libs/consts';
import type { ContentfulPageListingGroup } from 'js/src/libs/contentful-tools';
import { seedContentfulPageData } from 'js/src/libs/contentful-tools';
import type { ContentfulPageType } from 'js/src/libs/contentful-utils';

export type ContentfulPageProps = {
    content: ContentfulPageType;
    contentfulPageListings: ContentfulPageListingGroup[];
};

export function prepareContentfulPage(props: ContentfulPageProps) {
    // Without this the header and footer read their links off a script tag in the page, which
    // the server has no way to reach.
    seedContentfulPageData(props.contentfulPageListings ?? []);
    return ImmutableFromJS(props.content) as ImmutableMap<ContentfulPageType>;
}

export const ContentfulPageApp: React.FC<{ content: ImmutableMap<ContentfulPageType> }> = ({
    content,
}) => (
    <>
        <PublicPagesTrim headerBackgroundColor="white">
            <ContentfulPage data={content} />
        </PublicPagesTrim>
        <Toast.Component />
        <RequestErrorModal />
    </>
);
